import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@components/Typography';
import { Input } from '@components/Input';
import { useTranslation } from '@hooks';
import { CouponType } from '@constants/coupons';
import { Select } from '@components/Select';
import { CURRENCY_OPTIONS, Currencies } from '@constants/currencies';
import { StyledRadioButtons, TypeContainer, RadioButtonsWrapper } from './styles';

const OfferType = ({ isView }) => {
    const { control, setValue, watch, clearErrors } = useFormContext();
    const { t } = useTranslation();

    const type = watch('type');
    const minimumAmountCurrency = watch('minimumAmountCurrency');
    const currencySymbol = Currencies.find(c => c.code === minimumAmountCurrency)?.symbol || minimumAmountCurrency;

    return (
        <div>
            <Typography variant="subtitle1" sx={{ color: 'var(--text-primary)', marginBottom: '8px' }}>
                {t('CouponsPage.offerType')}
            </Typography>
            <Controller
                control={control}
                name="type"
                render={({ field }) => (
                    <RadioButtonsWrapper>
                        <StyledRadioButtons
                            id="pl-radiobuttons"
                            value={field.value}
                            onChange={value => {
                                setValue('type', value, { shouldDirty: true, shouldValidate: true });
                                clearErrors('percentageOff');
                                clearErrors('amountOff');
                                clearErrors('freeItem');
                            }}
                            options={[
                                { value: CouponType.PercentageOff, label: t('CouponsPage.percentageOff') },
                                { value: CouponType.AmountOff, label: t('CouponsPage.amountOff') },
                                { value: CouponType.FreeItem, label: t('CouponsPage.freeItem') },
                            ]}
                            disabled={isView}
                        />
                    </RadioButtonsWrapper>
                )}
            />
            <TypeContainer>
                {type === CouponType.PercentageOff ? (
                    <Controller
                        control={control}
                        name="percentageOff"
                        render={({ field, fieldState: { error }, ref }) => (
                            <Input
                                ref={ref}
                                inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                label={t('CouponsPage.percentageOff')}
                                fullWidth
                                error={!!error}
                                helperText={error ? t(error.message) : null}
                                required
                                type="number"
                                disabled={isView}
                                addonComponent={'%'}
                                addonWithoutWrapper
                            />
                        )}
                    />
                ) : null}
                {type === CouponType.AmountOff ? (
                    <Controller
                        control={control}
                        name="amountOff"
                        render={({ field, fieldState: { error }, ref }) => (
                            <Input
                                ref={ref}
                                inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                label={t('CouponsPage.amountOff')}
                                fullWidth
                                error={!!error}
                                helperText={error ? t(error.message) : null}
                                required
                                disabled={isView}
                            />
                        )}
                    />
                ) : null}
                {type === CouponType.FreeItem ? (
                    <Controller
                        control={control}
                        name="freeItem"
                        render={({ field, fieldState: { error }, ref }) => (
                            <Input
                                ref={ref}
                                inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                label={t('CouponsPage.freeItem')}
                                fullWidth
                                error={!!error}
                                helperText={error ? t(error.message) : null}
                                required
                                disabled={isView}
                            />
                        )}
                    />
                ) : null}
                <Controller
                    control={control}
                    name="minimumAmountCurrency"
                    render={({ field, fieldState: { error }, ref }) => (
                        <Select
                            {...field}
                            value={field.value ?? ''}
                            ref={ref}
                            label={t('common.currency')}
                            options={CURRENCY_OPTIONS}
                            error={!!error}
                            helperText={error ? t(error.message) : null}
                            required
                            disabled={isView}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="minimumAmount"
                    render={({ field, fieldState: { error }, ref }) => (
                        <Input
                            ref={ref}
                            inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                            label={t('CouponsPage.minimumOrderValue')}
                            addonComponent={currencySymbol}
                            addonWithoutWrapper
                            fullWidth
                            type="number"
                            error={!!error}
                            helperText={error ? t(error.message) : null}
                            disabled={isView}
                        />
                    )}
                />
            </TypeContainer>
        </div>
    );
};

export default OfferType;
